var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label || "Select"))]),_vm._v(" "),_c('select',{staticClass:"form-control",domProps:{"value":_vm.realValue},on:{"change":_vm.emitFilter}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(option.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }